import { render, staticRenderFns } from "./modal-status-ticket.vue?vue&type=template&id=552e4598&"
import script from "./modal-status-ticket.vue?vue&type=script&lang=js&"
export * from "./modal-status-ticket.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports